<template>
  <div v-if="shouldShow">
    <div class="activity-dialog">
      <el-dialog
        :show-close="false"
        :lock-scroll="true"
        custom-class="dialog"
        top="25vh"
        :close-on-click-modal="false"
        :visible.sync="showDialog"
        :modal-append-to-body="false"
      >
        <div class="bg-f br20 pt24 pb24 pl28 pr20">
          <div class="flex align-items-center">
            <span class="c333 fs16 font-weight-600">温馨提示</span>
            <!--            <img src="@cdn?081aaa4b53c4" class="w-12 h-12 cursor-pointer" @click="close" />-->
          </div>
          <div class="pt16 pb20 pr8 fs12 c333" style="line-height: 20px">
            感谢您使用蝉选，蝉选尊重并严格保护用户隐私， 请您仔细阅读并充分理解相关条款，以帮助您了解
            维护自己隐私权的方式。<br />
            您点击同意即表示您已阅读并通过<span class="color-[#ff5628] cursor-pointer" @click="userGo()"
              >《用户协议》</span
            >
            和<span class="color-[#ff5628] cursor-pointer" @click="yinsiGo">《隐私政策》</span
            >，我们将尽全力保护您的个人信息 和合法权益，感谢您信任并使用蝉选
          </div>
          <div class="flex justify-content-end">
            <el-button class="w-108 h-40 c333 font-weight-500 fs14 mr6" @click="onDelFunc"> 不同意 </el-button>
            <el-button type="primary" class="w-108 h-40" @click="onAgreeFunc"> 同意 </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getPrivacyVerify } from '@/services/module/user'
import { exitLogin, gotoCxLogin } from '@/common/login'
import { mapGetters } from 'vuex'
import { getJXAddress } from '@/common/login.js'

export default {
  name: 'AgreePrivacyDialog',
  data() {
    return {
      showDialog: false
    }
  },
  computed: {
    ...mapGetters('route', ['pageLoading']),
    // 根据页面加载以及路由元信息判断展示
    shouldShow() {
      return !this.pageLoading && !this.$route.meta.notShowDialog
    }
  },
  created() {
    this.$EventBus.$on('onOpenAgreePrivacyDialog', (data) => {
      console.log('ff')
      this.open()
    })
  },
  methods: {
    open() {
      this.showDialog = true
    },
    close() {
      this.showDialog = false
    },
    goActivity() {
      if (this.clickAble) {
        window.open(
          'https://mp.weixin.qq.com/s?__biz=Mzg4ODcwNTA4NQ==&mid=2247484889&idx=1&sn=ac372f157cf1717799ec0e406564e791&chksm=cff65c8bf881d59d16088e271998c17ba68a26149252934a27412de6cfb2f7623fda9c065928#rd',
          '_blank'
        )
      }
      this.close()
    },
    userGo() {
      console.log(`${getJXAddress}/h5/privacy-word/service`)
      window.open(`${getJXAddress()}/h5/privacy-word/service`)
    },
    yinsiGo() {
      window.open(`${getJXAddress()}/h5/privacy-word/policy`)
    },
    async onDelFunc() {
      this.close()
      await exitLogin()
      gotoCxLogin()
    },
    async onAgreeFunc() {
      try {
        const {
          data: { data, errCode, errMsg }
        } = await getPrivacyVerify()
        if (errCode != 0) {
          this.$message.error(errMsg)
          return
        }
        this.close()
        if (this.$route.name == 'Home') {
          this.$router.go(0)
        } else {
          this.$router.push({
            name: 'Home'
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-dialog {
  z-index: 10002;

  &::v-deep {
    .dialog {
      .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
      }

      width: 500px;
      height: 0;
      background: #fff !important;
      border-radius: 12px;
    }

    .el-dialog__header {
      display: none;
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
